import { useEffect, useState, useRef } from 'react';

import { Parameter } from '../../classess/parameter/parameter';
import { Customer } from '../../classess/customer/customer';

import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj, getResponse, getRolesType, handleResponseMessageAsync, settings, styles,
    getUserRoles, LoadingSection, awaitDelayAsync,
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import ParameterAdd from './ParameterAdd';
import Swal from 'sweetalert2';
import { ParameterService } from '../../services/parameters/ParameterService';
import AccessDenied from '../main/AccessDenied';
import TableIndex from '../main/TableIndex';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, icons, images, labels, messages, timers } = settings;

const currentMethod = 'Parameters';

export default function Parameters({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const isMount = useRef(true);
    const [process, setProcess] = useState({
        showLoading: false,
        addParameter: false,
        edit: false,
        delete: false,
        back: false,
    });
    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    let userRoles = getRolesType();
    userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod, })?.result;

    const dtParametersId = 'dtParameters';
    const [customers, setCustomers] = useState([]);
    const [showData, setShowData] = useState(true);
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        languageObj: languageObj,
        dtParametersId: dtParametersId,
        dtParametersRowId: 0,
        parameter: Parameter?.getClass({}, false),
        customers: [Customer?.getClass({}, false)],
        userRoles: userRoles,
    });
    const controls = {
        buttons: {
            addParameter: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddParameter',
            },
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnBack',
            },
        },
        dataTables: {
            parameters: {
                buttons: {
                    process: {
                        id: 2,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtParametersId}_filter input`,
                        defaultClass: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtParametersId}_length select`,
                        defaultClass: '',
                    },
                },
                paginateds: {
                    paginated: {
                        id: `${dtParametersId}_paginate`,
                        defaultClass: '',
                    }
                }
            },
        },
        icons: {
            addParameter: {
                id: 'iconAddParameter',
                defaultClass: icons?.fasFa?.plusCircle,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        spiners: {
            addParameter: {
                id: 'spAddParameter',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region parameter
    const getParameterAdd = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getParameterAdd';
        try {
            e?.preventDefault?.();

            //#region check role
            if (!userRoles?.isAdmin && !userRoles?.isAnalyst) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`;
                return;
            }
            //#endregion check role

            setProcess(prev => ({ ...prev, addParameter: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            //#region set data
            setModalObj(prev => ({
                ...prev,
                parameter: { ...prev?.parameter, customerId: 0 },
                type: 0,
                showModal: true,
                customers: customers,
            }));
            //#endregion set data
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, addParameter: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getParameterEditDetails = async ({
        e = {},
        id = 0,
        description = '',
        type = 0,
        rowId = '',
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getParameterEditDetails';
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, edit: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            window.location.href = type === 1 ?
                `${backend?.urls?.parameters}/${labels?.edit?.en?.toLowerCase()}/${id}` :
                `${backend?.urls?.parameters}/${labels?.details?.en?.toLowerCase()}/${id}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, edit: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const deleteParameter = async ({
        e = {},
        id = 0,
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'deleteParameter';
        try {
            e?.preventDefault?.();

            //#region show message
            let msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.parameter?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };
            const swalProperties = {
                icon: settings?.react?.sweetAlert2?.messages?.types?.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                showConfirmButton: !Swal.isLoading(),
                confirmButtonColor: settings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: settings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            html: msgTextObj?.two,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            showConfirmButton: false,
                        });

                        //#region delete data (parameter)
                        preConfirmResponse = await ParameterService.deleteAsync({
                            auth: auth,
                            id: id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (parameter)

                        //#region delete datatable (parameter)
                        $(`#${dtParametersId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);

                        preConfirmResponse = getResponse({
                            type: 0,
                            msgText: messages?.processCompletedSuccessfully?.[languageObj?.id]
                        });
                        //#endregion delete datatable (parameter)
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
                allowOutsideClick: () => !Swal.isLoading(),
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                }
            };

            const swalResult = await Swal.fire(swalProperties);
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            // setProcess not required here since Swal has its own loader
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion parameter

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (parameters)
                response = await ParameterService.getAll({
                    auth: auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                });

                if (!response?.isSuccess || response?.isWarning) return;

                const customersData = response?.result?.customers || [];
                customersData?.sort((a, b) => a.name > b.name ? 1 : -1);
                setCustomers(prev => customersData);
                const parametersData = response?.result?.parameters || [];
                const parameterDetailsData = response?.result?.parameterDetails || [];
                //#endregion get data (parameters)

                //#region set datatable
                if (parametersData?.length > 0 || parameterDetailsData?.length > 0 || customersData?.length > 0) {
                    response = setDataInDataTable({
                        data: parametersData,
                        dataDetails: parameterDetailsData,
                        customers: customersData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(prev => false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataTables';
        try {
            $(`#${dtParametersId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.customer?.[languageObj?.id], width: '80%', },
                    { title: labels?.devices?.[languageObj?.id], className: 'text-center', width: '15%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                fnDrawCallback: function () {
                    if ($ && $.fn && $.fn.dropdown) {
                        $('[data-toggle="dropdown"]').dropdown();
                    }
                },
            });
            //.buttons().container().appendTo(`#${dtParametersId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            $(`#${dtParametersId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtParametersId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getParameterEditDetails({ e: e, id: parseInt(id_), description: description, type: 1, rowId: rowId, subMethod: currentMethod });
                            break;
                        case 'details':
                            getParameterEditDetails({ e: e, id: parseInt(id_), description: description, type: 2, rowId: rowId, subMethod: currentMethod });
                            break;
                        case 'delete':
                            deleteParameter({ e: e, id: parseInt(id_), description: description, rowId: rowId, subMethod: currentMethod });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        dataDetails = [],
        customers = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            const rowsDt = [];
            data?.forEach((parameter) => {
                const modelParameter = Parameter?.getClass(parameter, false);
                const modelCustomer = customers?.filter(({ id }) => id === modelParameter?.customerId)[0] || {};
                const modelParameterDetails = dataDetails?.filter(({ parameterId }) => parameterId === modelParameter?.id) || [];
                const processButtons = [];

                rowsDt.push([
                    modelCustomer?.name || '',
                    modelParameterDetails?.length || 0,
                    getProcessButtons({
                        id: parameter?.id,
                        description: modelCustomer?.name,
                        showDetails: true,
                        labelDetails: labels?.details?.[languageObj?.id],
                        enabledDetails: true,
                        showDelete: (userRoles?.isAdmin || userRoles?.isAnalyst),
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: (userRoles?.isAdmin || userRoles?.isAnalyst),
                        showEdit: (userRoles?.isAdmin || userRoles?.isAnalyst),
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: (userRoles?.isAdmin || userRoles?.isAnalyst),
                        processButtons: processButtons,
                    })?.result,
                ]);
            });
            $(`#${dtParametersId}`)?.DataTable()?.rows?.add(rowsDt)?.draw(true);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.services?.services} process={app?.views?.parameters?.parameters} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.parameters?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.parameters?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                borderRadius='10px'
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.parameters?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.parameters} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.parameters?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.cogs} mr-1`}></i> {labels?.index?.[languageObj?.id] || 'Maintenance'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='ml-auto'>
                                                        <div className='d-flex flex-wrap justify-content-end align-items-center' style={{ gap: '8px' }}>
                                                            <button id={controls?.buttons?.addParameter?.id}
                                                                type='button'
                                                                hidden={!userRoles?.isAdmin && !userRoles?.isAnalyst}
                                                                disabled={process?.showLoading || (!userRoles?.isAdmin && !userRoles?.isAnalyst)}
                                                                className={controls?.buttons?.addParameter?.defaultClass}
                                                                title={labels?.add?.[languageObj?.id]}
                                                                onClick={(e) => getParameterAdd({ e: e, subMethod: controls?.buttons?.addParameter?.id })}
                                                                style={{ borderRadius: '5px' }}>
                                                                {!process?.addParameter ? (
                                                                    <i id={controls?.icons?.addParameter?.id} className={controls?.icons?.addParameter?.defaultClass} />
                                                                ) : (
                                                                    <span id={controls?.spiners?.addParameter?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                                )} {labels?.add?.[languageObj?.id]}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtParametersId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section>

            </div>

            {modalObj?.showModal ?
                <ParameterAdd auth={auth}
                    modalObj={modalObj}
                    setModalObj={setModalObj} />
                :
                <div></div>
            }
        </div>
    )
}